"use client";

import ThemeProvider from "src/lib/components/salify-next-layout/default/theme/theme-provider";
import {
  extractMuiThemeOverride,
  parseThemeFromSiteBuilderLayout,
} from "src/lib/theme/salify-ui-theme";

/** Applies page-level theme (page >> site >> system) from document inquiry. */
const DocumentThemeProvider = ({
  theme,
  children,
}: React.PropsWithChildren<{ theme?: Record<string, any> }>) => {
  const muiOverride = extractMuiThemeOverride(theme);
  if (!muiOverride) return children;

  const themeId = parseThemeFromSiteBuilderLayout({ layout: { theme } }) || "DEFAULT";

  return (
    <ThemeProvider theme={themeId} themeOptionsOverride={muiOverride}>
      {children}
    </ThemeProvider>
  );
};

export default DocumentThemeProvider;
